import React from 'react';
import { Modal } from 'antd';
import MonacoEditor from '@monaco-editor/react';

const mode = {
  python3: 'python',
  javascript: 'javascript',
  c: 'c',
  cpp: 'cpp',
  java: 'java',
  ruby3: 'ruby',
};

const DriverCodeModal = ({ open, onCancel, lang, activeTemplate, theme }) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width="60%"
      style={{ top: '100px', padding: 0 }}
      styles={{ body: { height: '70vh', padding: '20px' } }}
      footer={null}
    >
      <div style={{ margin: 'auto', height: '80%' }}>
        <p style={{ paddingBottom: '20px' }}>
          <i style={{ fontSize: '20px', fontStyle: 'italic' }}>
            This is the driver code that will run your solution. Review it to understand how test
            cases are read and how your return values are processed. No action is needed here—focus
            on your specific algorithm.
          </i>
        </p>
        <MonacoEditor
          key={`${lang}-${open}-${theme}`}
          height="100%"
          language={mode[lang] || lang}
          theme={theme}
          value={`${activeTemplate?.header || ''}\n${activeTemplate?.body || ''}\n${
            activeTemplate?.tailer || ''
          }`}
          options={{
            readOnly: true,
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            contextmenu: false,
          }}
          onMount={(editor, monaco) => {
            monaco.editor.setTheme(theme);

            const headerLines = (activeTemplate?.header || '').split('\n').length;
            const bodyLines = (activeTemplate?.body || '').split('\n').length;
            const tailLines = (activeTemplate?.tailer || '').split('\n').length;

            // Calculate tail start line accurately
            const tailStart = headerLines + bodyLines + 1;

            const isDarkTheme = theme === 'vs-dark';
            const headerClass = isDarkTheme ? 'template-header-bg-dark' : 'template-header-bg';
            const tailClass = isDarkTheme ? 'template-tail-bg-dark' : 'template-tail-bg';

            const decorations = [
              {
                range: new monaco.Range(1, 1, headerLines, 1000000),
                options: {
                  className: headerClass,
                  inlineClassName: headerClass,
                  isWholeLine: true,
                },
              },
            ];

            if (activeTemplate?.tailer && activeTemplate.tailer.trim() !== '') {
              decorations.push({
                range: new monaco.Range(tailStart, 1, tailStart + tailLines - 1, 1000000),
                options: {
                  className: tailClass,
                  inlineClassName: tailClass,
                  isWholeLine: true,
                },
              });
            }

            editor.createDecorationsCollection(decorations);
          }}
        />
      </div>
    </Modal>
  );
};

export default DriverCodeModal;
